// Imports
// ------
import React from 'react';
import MortgageContent from './content';
import MortgageQuestions from './questions';
import styled, { css } from 'styled-components';
import { Section, Div } from '@reuse';
import { breakup } from '@break';
import { Row, Column } from 'react-foundation';


// Styles
// ------
const sharedStyles = css`
    position: relative;
    width: 100%;
    height: auto;
`;

const Sector = styled(Section)`
    ${sharedStyles}
`;

const Jacket = styled(Div)`
    ${sharedStyles}
`;

const Children = styled(Div)`
    position: relative;

    &:before {
        content: '';
        position: absolute;
        z-index: -1;
        top: 0; left: 0; right: 0; bottom: 0;
        background-color: ${props => props.theme.bc1};

        ${breakup.large` left: 8.333%; `}
    }
`;

// Component
// ------
class MortgageSector extends React.PureComponent {
    render() {
        return (
            <Sector>
                <Jacket bc1>
                    <Row isExpanded isCollapsed>
                        <Column small={12} medium={11}>
                            <MortgageContent content={this.props.content} />
                        </Column>
                    </Row>
                </Jacket>
                
                <Children padTop>
                    <MortgageQuestions content={this.props.questions} />
                </Children>
            </Sector>
        )
    }
}

export default MortgageSector;